export default "__VITE_ASSET__408210d3__"